import React, { useEffect } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import useBatchTopicRequest from '../../../../hooks/useBatchTopicRequest';
import KeywordItem from '@/pages/opinion/components/Snippets/KeywordItem';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useHistory, useIntl } from 'umi';
import { LanguageType } from '@/pages/opinion/types/common';
import { goStatsDetailAction } from '@/pages/opinion/pages/stats/Detail';
import BubbleCommon, {
  competitorNegativeTopicTips,
  competitorPositiveTopicTips,
} from '@/pages/opinion/components/BubbleCommon';

export default function TopicRow({
  isShadow,
  games,
  filter,
  lang,
  isCache,
  translateTopicFunc,
}: {
  isCache: boolean;
  isShadow: boolean;
  listObj: Array<any>;
  games: Array<any>;
  filter: any;
  lang: LanguageType;
  translateTopicFunc?: () => string;
}) {
  const {
    keywordsInPosTopic,
    keywordsInNegTopic,
    topicKeywordsLoading,
    topicKeywordsApiError,
    topicKeywords,
    getTopicKeywords,
  } = useBatchTopicRequest();

  useEffect(() => {
    if (games.length > 0 && filter && !isCache) {
      getTopicKeywords({ ...filter, games });
    }
  }, [games]);

  const renderList = [
    {
      key: 'Keywords',
      data: topicKeywords,
    },
    {
      key: 'Positive Topic',
      icon: 'laugh-green-color',
      data: keywordsInPosTopic,
      tips: competitorPositiveTopicTips,
    },
    {
      key: 'Negative Topic',
      icon: 'laugh-red-color',
      data: keywordsInNegTopic,
      tips: competitorNegativeTopicTips,
    },
  ];
  const { formatMessage } = useIntl();

  return (
    <CardCommon contentCard loading={topicKeywordsLoading} loadingHeight={300}>
      <>
        {renderList.map(({ key, icon, data, tips }) => {
          return (
            <div className="table-context-item" key={key}>
              <div className="first-col table-item text-name">
                <BubbleCommon tipsMap={tips} showIcon={false}>
                  {formatMessage({ id: key })}
                  {icon && <SvgIcon type={icon} className="tip-icon" />}
                </BubbleCommon>
              </div>
              {games.map((game: any, i: any) => {
                const { edition_unified_id } = game;

                const info = data?.[edition_unified_id] || [];
                return (
                  <div
                    className={`col-padding dbo-topic-row ${
                      i == 0 && isShadow ? 'sticky-text' : ''
                    }`}
                    key={i}
                  >
                    {info?.length > 0 ? (
                      <TableRow3
                        data={info}
                        translateTopicFunc={translateTopicFunc}
                        lang={lang}
                        isKeyword={key === 'Keywords'}
                        filter={filter}
                        game={game}
                      />
                    ) : (
                      <div className="no-data-style">
                        {formatMessage({ id: 'No data' })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </>
    </CardCommon>
  );
}

// Topic模块局部展示数据
const TableRow3 = ({
  data,
  isKeyword,
  lang,
  filter,
  game,
  translateTopicFunc,
}: any) => {
  // 竞选跳转详情下钻
  const getDetails = () => {};
  const history = useHistory();

  const getKeywordElement = (list: any, topicName?: string) => {
    return (
      <div className="tip-flex">
        {(list || [])?.map((t: any) => {
          return (
            <KeywordItem
              key={t.name + t.mentions + t.mentions}
              language={lang}
              keyword={t}
              hideCount={false}
              sentiment_rating={t.sentiment}
              count={t.mentions}
              itemClick={() => {
                console.log('click', t, isKeyword);

                // 按照旧风格，如果是 keyword 上的，直接取关键词。如果是 topic 下的，取 child

                let keyword = [];
                let topic: any = [];

                if (isKeyword) {
                  keyword = [t.name];
                } else {
                  const keywordChild = t?.child;

                  if (Array.isArray(keywordChild) && keywordChild?.length > 0) {
                    keyword = keywordChild.map((item) => item.name);
                  }

                  topic = topicName ? [topicName] : [];
                }

                goStatsDetailAction({
                  params: {
                    filter: {
                      ...filter,
                      ...game,
                      keyword,
                      topic,
                    },
                    statsDetailType: isKeyword
                      ? 'competitor-keyword'
                      : 'competitor-topic',
                    hasHeaderGame: true,
                    headerGameInfo: game,
                  },
                  history,
                });
              }}
              languageMap={{
                origin: 'name',
                en: 'name_en',
                zh: 'name_cn',
              }}
            ></KeywordItem>
          );
        })}
      </div>
    );
  };

  if (isKeyword) {
    return <div className="dbo-text-tip">{getKeywordElement(data)}</div>;
  }

  return data.map((e: any, i: any) => {
    return (
      <div className="dbo-text-tip" key={e.topic_name + i}>
        {e?.topic_name ? (
          <div className="tip-text">{translateTopicFunc(e.topic_name)}</div>
        ) : (
          ''
        )}
        <div className="dbo-text-tip">
          {getKeywordElement(e.keywords, e.topic_name)}
        </div>
      </div>
    );
  });
};
